// Third Party
import * as $ from 'jquery';
import DatePicker from 'vue2-datepicker';
import { format } from 'date-fns'; 

// Mixins
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';
import { dateMixins } from '@/app/mixins/utils/date-mixins.js';
import { userMixins } from '@/app/mixins/modules/user-mixins.js';

// Services
import breedingManagementService from "@/app/services/main/breeding-management/breeding-management-service.js";

// Constants
import { STATUS_CODES, SUCCESS_MSG } from '@/app/constants/status-constants';
import { BREEDER_ROUTES } from '@/app/constants/breeder-routes-constants';

// Utils

export default {
    name: 'ModalAddWhelpBirthType',
    components: {
        DatePicker
    },
    mixins: [ toastMessageMixins, dateMixins, userMixins ],
    data() {
        return {
            modalContent: {},
            whelpingDate: null,
            selectedBirthType: null,
            typeOfBirthList: ["Natural", "C-section"],
            whelpingDateErr: false
        }
    },
    computed: {},
    beforeDestroy() {
		this.hideModal();
	},
    methods: {
        show(content) {
            this.modalContent =  content
            this.whelpingDateErr = false
            $(this.$refs.modalAddWhelpBirthType).modal('show');

            this.whelpingDate = content.whelpingDate ? new Date(content.whelpingDate) : null;
        },

        hideModal() {
            $(this.$refs.modalAddWhelpBirthType).modal('hide');

            // reset states
            this.whelpingDate = null;
            this.whelpingDateErr = false;

        },

        async onSaveData (birthType) {
            try {
                if(this.whelpingDate){
                    const { SUCCESS_ADD_WHELP_TYPE_OF_BIRTH, ERROR_ADD_WHELP_TYPE_OF_BIRTH } = this.toastMessages.mating();
                    const dateFormat = "yyyy-MM-dd";
                    const detailsToSave = {
                        cycleDetails: {
                            damId: this.modalContent.damId,
                            matingId: this.modalContent.matingId,
                            typeOfBirth: birthType,
                            whelpingDate: this.whelpingDate ? this.formatDateWithoutConversion(this.whelpingDate, dateFormat) : null,
                        }
                    }
    
                    const response = await breedingManagementService.updateDamWhelpDateAndTypeOfBirth(detailsToSave);
    
                    if (response.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
                        this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, SUCCESS_ADD_WHELP_TYPE_OF_BIRTH);
                        let route = BREEDER_ROUTES.LITTER_LIST
                        this.$router.push(`${route}?id=${this.modalContent.matingId}&from=mating-list`);
                    } else {
                        this.showAPIErrorToast(ERROR_ADD_WHELP_TYPE_OF_BIRTH, response);
                    }
                } else {
                    this.whelpingDateErr = true
                }
                
            } catch (err) {
                throw err;
            }
        }
    }       
}